(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.FieldSelectionController = (function(superClass) {
    extend(FieldSelectionController, superClass);

    function FieldSelectionController(scope, transitions, modal, http, service, state) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.countUnselectedFields = bind(this.countUnselectedFields, this);
      this.deselectAll = bind(this.deselectAll, this);
      this.selectAll = bind(this.selectAll, this);
      this.toggleFieldSelection = bind(this.toggleFieldSelection, this);
      this.deselectField = bind(this.deselectField, this);
      this.selectField = bind(this.selectField, this);
      this.fieldSelected = bind(this.fieldSelected, this);
      this.rxMapDeliveredForField = bind(this.rxMapDeliveredForField, this);
      this.cropThatPreventsFieldBeingSelected = bind(this.cropThatPreventsFieldBeingSelected, this);
      this.fieldName = bind(this.fieldName, this);
      FieldSelectionController.__super__.constructor.apply(this, arguments);
      this.http.get('api/fields').then((function(_this) {
        return function(response) {
          return _this.fields = _.sortBy(response.data, 'farm_name', 'field_name').map(function(field) {
            field.selected = false;
            return field;
          });
        };
      })(this));
      this.http.get('api/nitrogen-surveys').then((function(_this) {
        return function(response) {
          return _this.surveys = _.filter(response.data, function(survey) {
            return survey.year === _this.service.year;
          });
        };
      })(this));
    }

    FieldSelectionController.prototype.fieldName = function(field) {
      return (field != null ? field.farm_name : void 0) + " - " + (field != null ? field.field_name : void 0);
    };

    FieldSelectionController.prototype.cropThatPreventsFieldBeingSelected = function(field) {
      var otherSurvey, ref;
      if (this.surveys == null) {
        return true;
      }
      if ((ref = this.service.crop) === 'Corn (grain)' || ref === 'Sorghum') {
        otherSurvey = _.find(this.surveys, (function(_this) {
          return function(survey) {
            var ref1;
            return ((ref1 = survey.crop.name) === 'Corn (grain)' || ref1 === 'Sorghum') && survey.crop.name !== _this.service.crop;
          };
        })(this));
        if (!otherSurvey) {
          return null;
        }
        if (_.find(otherSurvey.fields_nitrogen_surveys, {
          fields_id: field.fields_id
        })) {
          return otherSurvey.crop.name;
        }
      }
      return null;
    };

    FieldSelectionController.prototype.rxMapDeliveredForField = function(field) {
      var ref;
      return ((ref = this.service.rxMaps[field.fields_id]) != null ? ref.length : void 0) > 0;
    };

    FieldSelectionController.prototype.fieldSelected = function(field) {
      var ref;
      return _.find((ref = this.service.survey) != null ? ref.fields_nitrogen_surveys : void 0, {
        fields_id: field.fields_id
      });
    };

    FieldSelectionController.prototype.selectField = function(field) {
      if (!this.fieldSelected(field)) {
        return this.service.survey.fields_nitrogen_surveys.push({
          fields_id: field.fields_id,
          field_name: field.field_name,
          farm_name: field.farm_name,
          complete: false,
          data: {},
          events: {
            planting: [],
            fertilizer: [],
            spraying: []
          },
          growth_stage_last_updated: null
        });
      }
    };

    FieldSelectionController.prototype.deselectField = function(field) {
      if (this.fieldSelected(field)) {
        return _.remove(this.service.survey.fields_nitrogen_surveys, (function(_this) {
          return function(value) {
            return value.fields_id === field.fields_id;
          };
        })(this));
      }
    };

    FieldSelectionController.prototype.toggleFieldSelection = function(field) {
      if (this.fieldSelected(field)) {
        return this.deselectField(field);
      } else {
        return this.selectField(field);
      }
    };

    FieldSelectionController.prototype.selectAll = function() {
      var field, i, len, ref, results;
      ref = this.fields;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        if (!this.cropThatPreventsFieldBeingSelected(field)) {
          results.push(this.selectField(field));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    FieldSelectionController.prototype.deselectAll = function() {
      var field, i, len, ref, results;
      ref = this.fields;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        if (!this.rxMapDeliveredForField(field)) {
          results.push(this.deselectField(field));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    FieldSelectionController.prototype.countUnselectedFields = function() {
      if (!this.fields) {
        return 1;
      }
      return _.filter(this.fields, (function(_this) {
        return function(field) {
          return !_this.fieldSelected(field) && !_this.cropThatPreventsFieldBeingSelected(field);
        };
      })(this)).length;
    };

    return FieldSelectionController;

  })(Controller);

}).call(this);
